<template>
  <div class="addplace-page container">
    <h1 class="title">Adicionar tradução (Idioma: {{$route.query.lang}})</h1>
    <div class="page-content">
      <place-translate-form
        :onSubmit="addPlaceTranslation"
        :is-disabled="isFormDisabled"
        :is-loading="isFormDisabled"
        button-label="Adicionar Tradução"
      />
      <p class="has-text-centered">
        <router-link :to="`/${$route.params.lang}/places`" class="button is-link">Voltar para listagem de Lugares</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import AsideMenuCtrlMixin from './AsideMenuCtrlMixin'
import PlaceTranslateForm from '../forms/PlaceTranslateForm'
import { CreatePlaceTranslation } from '../../api/place'
import { prepareFormData } from '../../helpers'

export default {
  name: 'AddPlaceTranslationPage',
  mixins: [AsideMenuCtrlMixin],
  components: { PlaceTranslateForm },
  data () {
    return {
      isFormDisabled: false
    }
  },
  methods: {
    addPlaceTranslation (data) {
      this.isFormDisabled = true
      CreatePlaceTranslation(
        prepareFormData({
          ...data,
          language: this.$route.query.lang
        }),
        this.$route.params.placeId
      )
        .then(
          success => {
            this.$modal.open({
              title: 'Sucesso!',
              content: 'Tradução adicionada com sucesso!',
              showCancel: false,
              onOk: () => {
                this.$router.push(`/${this.$route.params.lang}/places`)
              }
            })
            this.isFormDisabled = false
            console.log(success)
          },
          error => {
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível criar a Tradução agora agora. Tente novamente.',
              duration: 10000
            })
            this.isFormDisabled = false
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/AddPlaceTranslationPage.vue